module.exports = __webpack_public_path__ + "img/ruoyi13.76bfa4af.png";